import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import DownloadFileButton from 'publisher/components/entities/button-new/download-file-button'
import OpenUrlButton from 'publisher/components/entities/button-new/open-url-button'
import ShowPopupButton from 'publisher/components/entities/button-new/show-popup-button'
import { useDelay } from 'publisher/hooks/useDelay'
import React from 'react'
import { WebsiteButtonInterface } from 'src/shared/types/entities/website-button-interface'

export interface WebsiteButtonProps {
  entity: WebsiteButtonInterface
}

export const WebsiteButton = ({ entity }: WebsiteButtonProps) => {
  const isVisible = useDelay(entity.delay)

  if (!isVisible) {
    return <div />
  }

  switch (entity.action) {
    case ButtonActionTypeEnum.WebsitePageLink:
    case ButtonActionTypeEnum.OpenUrl:
      return <OpenUrlButton entity={entity} />
    case ButtonActionTypeEnum.DownloadFile:
      return <DownloadFileButton entity={entity} />
    case ButtonActionTypeEnum.ShowPopup:
      return <ShowPopupButton entity={entity} />
    default:
      return <div />
  }
}
